import actions from './actionTypes';
import {
  canvasDidResize,
  resetProject,
  updateProjectPlacingsCoords,
  updateMeasurementLines,
  setShowPixelationWarningField
} from './fabricCanvasActions';
import { string } from '../localization/Localization';
import * as Constants from '../utilities/constants/Constants';
import { setCurrentPageIndex, setModalPageMode } from './pageControllerActions';
import {
  convertFromMetricToImperial,
  orientationSupportedProducts,
  isSignageSuiteProduct,
  checkIfLaptopAppBeforeProductSelection,
  checkIfMaskAppBeforeProductSelection,
  isGroupSettingsSupportedApp,
  isMultiCanvas,
  isCanvasAppFromURL
} from '../utilities/HelperFunctions/HelperFunctions';
import { saveLanguageKey } from '../utilities/CookieUtils/CookieUtils';
import {
  generateProductSpecificThemeFolders,
  initializeProductSizes
} from './modalActions';
import {
  setMessageDialogParams,
  sendReviewOrderGA,
  setSidebarVisibility
} from './fabricCanvasActions';
import {
  isTurkeyLaptop,
  checkForDesignCompetition,
  checkForDesignEnterprise,
  isCanvasApp
} from '../utilities/HelperFunctions/SignageHelperFunctions';
import { handleTabChange } from './sideBarActions';
import { Wall } from './ProjectData/Wall';
import { initializeWalls } from './ProjectData/Project';
import { loadInspirations } from './sideBarActions';
import { updateStoreWithProductSettings } from './ProjectData/Store';
import { setCanvasTileType } from './finalCheckActions';
import {
  customHeightChange,
  customWidthChange,
  doesProjectSizeExceedsWallSize,
  sizeSettingsAreChanged,
  setSizeExceedValidationResult,
  resetMultiCanvasErrorState
} from './actions/sizeHandler';
import { isPosterCategory } from './fabricCanvasActionHelpers';

export const setLandingPage = () => dispatch => {
  if (isSignageSuiteProduct() || isCanvasAppFromURL()) {
    dispatch({
      type: actions.SET_PAGE_INDEX,
      payload: {
        currentPageIndex: Constants.PRODUCT_GROUP_PAGE
      }
    });
  } else {
    dispatch({
      type: actions.SET_PAGE_INDEX,
      payload: {
        currentPageIndex: Constants.SIZE_SELECTION_PAGE
      }
    });
  }
};

export const modelIsSelected = () => (dispatch, getState) => {
  const { multiWallProjects } = getState().finalCheck;
  if (isSignageSuiteProduct() || multiWallProjects.length > 1) {
    dispatch(projectResetAlert());
    dispatch(sendReviewOrderGA(true));
  } else {
    dispatch(updateProjectPlacingsCoords());
    dispatch(setModalPageMode(true));
    const isCanvas = dispatch(checkIfCanvasApp());
    let wallWidth = null;
    let wallHeight = null;
    if (isCanvas) {
      wallWidth = Constants.DEFAULT_WALL_WIDTH;
      wallHeight = Constants.DEFAULT_WALL_HEIGHT;
    }
    dispatch(selectWall(wallWidth, wallHeight));
    dispatch(customHeightChange(null)); // Clearing custom height
    dispatch(customWidthChange(null)); // Clearing custom width
    if (isCanvas) {
      dispatch(setCurrentPageIndex(Constants.PRODUCT_GROUP_PAGE));
      dispatch({
        type: actions.SET_ROW,
        payload: { value: 1, rowInput: 1 }
      });
      dispatch({
        type: actions.SET_COLUMN,
        payload: { value: 1, columnInput: 1 }
      });
      dispatch(resetMultiCanvasErrorState());
    } else {
      dispatch(setSelectedDefaultSize(0));
      dispatch(setCurrentPageIndex(Constants.SIZE_SELECTION_PAGE));
    }
  }
};

export const isCustomSizeAvailableInProjectLaunch = (
  variableSizeType,
  allowCustomSizeInPreset
) => variableSizeType == 'custom' || allowCustomSizeInPreset;

// Lite version is an excepton: It can have variable size type as Custom But still has preset values.
export const isPresetSizeAvailableInLaunch = variableSizeType => (
  dispatch,
  getState
) => variableSizeType == 'preset' || getState().modal.envData.is_lite_patner;

const projectResetAlert = () => dispatch => {
  const dict = {
    header: string.RESTART_PROJECT_ALERT_TITLE,
    description: string.DISCARD_ALERT_MESSAGE,
    stringColor: Constants.DEFAULT_STRING_COLOR,
    onclick: () => dispatch(restartProject()),
    onCancel: null,
    buttonTitles: { finish: string.RESTART, cancel: string.CANCEL_TEXT_KEY }
  };
  dispatch(setMessageDialogParams(dict));
};

export const sizeDropdownIsChanged = inSelectedSize => dispatch => {
  let selectedSize = inSelectedSize;
  if (selectedSize < 0) {
    selectedSize = 0;
  }
  dispatch(setSelectedDefaultSize(selectedSize));
};

export const setSelectedDefaultSize = index => dispatch => {
  dispatch({
    type: actions.SELECT_DEFAULT_WALL_CHANGE,
    payload: { selectedSize: index }
  });
  if (dispatch(checkIfCanvasApp())) {
    if (index == 'custom') {
      dispatch(setCanvasTileType(Constants.CANVAS_FREESTYLE_TILE_TYPE));
    } else {
      dispatch(setCanvasTileType(Constants.CANVAS_CONSTRAINT_TILE_TYPE));
    }
  }
};

export const updateModelsForSelectedWallSize = (width, height) => (
  dispatch,
  getState
) => {
  const { selectedProduct } = getState().home;
  if (selectedProduct) {
    const { productSizes } = selectedProduct;
    const wallaspectRato = width / height;

    let matchedProductSizeIndex = 0;
    let oldDiff = Math.abs(wallaspectRato - productSizes[0].aspectRatio);

    productSizes.forEach((productSize, index) => {
      const newDiff = Math.abs(wallaspectRato - productSize.aspectRatio);
      if (oldDiff >= newDiff) {
        oldDiff = newDiff;
        matchedProductSizeIndex = index;
      }
    });
    selectedProduct.activeProductSize = productSizes[matchedProductSizeIndex];
    const [defaultTemplate] = selectedProduct.activeProductSize.templates;
    selectedProduct.activeProductSize.activeTemplate = defaultTemplate;
  }
};

export const selectWall = (wallWidth, wallHeight) => (dispatch, getState) => {
  const isCanvas = dispatch(checkIfCanvasApp());
  if (isCanvas) {
    if (getState().home.selectedDefaultSize == Constants.CUSTOM_SIZE) {
      const { customWidth, customHeight } = getState().home.customWall;
      const widthStringToFloatValue = parseFloat(customWidth);
      const heightStringToFloatValue = parseFloat(customHeight);
      const { row, column } = getState().home.multiCanvas;
      dispatch(
        sizeSettingsAreChanged(
          widthStringToFloatValue,
          heightStringToFloatValue,
          row,
          column,
          wallWidth,
          wallHeight
        )
      );
    } else {
      const { width, height } = getState().modal.productSizes.default.sizes[
        getState().home.selectedDefaultSize
      ];
      const { row, column } = getState().home.multiCanvas;
      dispatch(
        sizeSettingsAreChanged(
          width * column,
          height * row,
          row,
          column,
          wallWidth,
          wallHeight
        )
      );
    }
  } else {
    dispatch(
      sizeSettingsAreChanged(wallWidth, wallHeight, 1, 1, wallWidth, wallHeight)
    );
  }
};

export const selectPresetWall = () => (dispatch, getState) => {
  const { width, height } = getState().modal.productSizes.default.sizes[
    getState().home.selectedDefaultSize
  ];
  let wallWidth = null;
  let wallHeight = null;
  let canContinue = false;
  if (dispatch(checkIfCanvasApp())) {
    const { rowInput, columnInput } = getState().home.multiCanvas;
    const { canvasWallWidth, canvasWallHeight } = getState().home.canvasWall;
    let isValidValuesToContinue = rowInput >= 1 && columnInput >= 1;
    if (isValidValuesToContinue) {
      const { isValid, projectWidthValid, projectHeightValid } = dispatch(
        doesProjectSizeExceedsWallSize(width * columnInput, height * rowInput)
      );
      dispatch(
        setSizeExceedValidationResult(projectWidthValid, projectHeightValid)
      );
      isValidValuesToContinue = isValidValuesToContinue && isValid;
    }
    if (isValidValuesToContinue) {
      dispatch({
        type: actions.SET_ROW,
        payload: { value: rowInput, rowInput }
      });
      dispatch({
        type: actions.SET_COLUMN,
        payload: { value: columnInput, columnInput }
      });
      wallWidth = canvasWallWidth;
      wallHeight = canvasWallHeight;
      canContinue = true;
    }
  } else {
    wallWidth = width;
    wallHeight = height;
    canContinue = true;
  }
  if (canContinue) {
    dispatch(updateModelsForSelectedWallSize(wallWidth, wallHeight));
    dispatch(selectWall(wallWidth, wallHeight));
    dispatch(updateOrientation(wallWidth, wallHeight));
  }
};

export const setDefaultWallVanilla = () => (dispatch, getState) => {
  const size = getState().modal.productSizes.default;
  const wall = size.sizes.findIndex(x => x.name === 'A2');
  dispatch(sizeDropdownIsChanged(wall));
  dispatch(selectPresetWall());
};

export const selectCustomWall = e => dispatch => {
  e.preventDefault();
  dispatch(customWallIsSelected());
};

export const setCanvasType = val => dispatch => {
  dispatch({
    type: actions.SET_CANVAS_TYPE,
    payload: { canvasType: val }
  });
};

export const updateMultiCanvas = e => () => {
  e.preventDefault();
};

export const setMultiCanvasPopoverStatus = val => (dispatch, getState) => {
  if (val) {
    dispatch({
      type: actions.SET_PROJECT_SIZE,
      payload: { width: null, height: null }
    });
    getState().finalCheck.project.canvasTileType = null;
  }
  dispatch({
    type: actions.SET_MULTICANVAS_POPOVER_STATUS,
    payload: { status: val }
  });
};

export const customWallIsSelected = () => (dispatch, getState) => {
  const {
    customWidth,
    customHeight,
    widthValid,
    heightValid
  } = getState().home.customWall;
  const widthStringToFloatValue = parseFloat(customWidth);
  const heightStringToFloatValue = parseFloat(customHeight);

  let wallWidth = null;
  let wallHeight = null;
  let canContinue = widthValid == '' && heightValid == '';

  if (dispatch(checkIfCanvasApp())) {
    const {
      rowInput,
      columnInput,
      rowValid,
      columnValid
    } = getState().home.multiCanvas;

    const { canvasWallWidth, canvasWallHeight } = getState().home.canvasWall;
    canContinue =
      canContinue &&
      rowInput >= 1 &&
      columnInput >= 1 &&
      rowValid == '' &&
      columnValid == '';

    if (canContinue) {
      const { isValid, projectWidthValid, projectHeightValid } = dispatch(
        doesProjectSizeExceedsWallSize(
          widthStringToFloatValue,
          heightStringToFloatValue
        )
      );
      dispatch(
        setSizeExceedValidationResult(projectWidthValid, projectHeightValid)
      );
      canContinue = canContinue && isValid;
    }
    wallWidth = canvasWallWidth;
    wallHeight = canvasWallHeight;
  } else {
    wallWidth = widthStringToFloatValue;
    wallHeight = heightStringToFloatValue;
  }

  if (canContinue) {
    dispatch(updateModelsForSelectedWallSize(wallWidth, wallHeight));
    dispatch(selectWall(wallWidth, wallHeight));
    dispatch(updateOrientation(wallWidth, wallHeight));
  }
};

export const getActiveWall = () => (dispatch, getState) => {
  if (!getState().finalCheck.project.activeWall) {
    const productWalls = [];
    const wallTeplate = {
      id: null,
      width: !dispatch(checkIfCanvasApp())
        ? Constants.DEFAULT_PROJECT_WIDTH
        : Constants.DEFAULT_WALL_WIDTH,
      height: !dispatch(checkIfCanvasApp())
        ? Constants.DEFAULT_PROJECT_HEIGHT
        : Constants.DEFAULT_WALL_HEIGHT
    };
    if (isSignageSuiteProduct()) {
      const { selectedProduct } = getState().home;
      if (selectedProduct) {
        const { activeProductSize } = selectedProduct;
        if (activeProductSize) {
          activeProductSize.templates.forEach(template => {
            productWalls.push({
              id: null,
              width: template.width,
              height: template.height
            });
          });
        } else {
          productWalls.push(wallTeplate);
        }
      } else {
        productWalls.push(wallTeplate);
      }
    } else {
      productWalls.push(wallTeplate);
    }
    initializeWalls(getState().finalCheck.project, productWalls);
  }
  const { activeWall } = getState().finalCheck.project;
  return activeWall;
};

export const updateCanvasForChangeInSize = () => (dispatch, getState) => {
  const { dimensions } = getState().fabricCanvas;
  dispatch(
    canvasDidResize(dimensions.orgWindowWidth, dimensions.orgWindowHeight)
  );
};

export const settingsWallChange = selectedSize => dispatch => {
  dispatch(sizeDropdownIsChanged(selectedSize));
  if (selectedSize === 'custom') {
    dispatch(customWallIsSelected());
  } else {
    dispatch(selectPresetWall());
  }
};

export const updateUIForProjectSize = (width, height) => (
  dispatch,
  getState
) => {
  dispatch(updateOrientation(width, height));
  const productSizes = getState().modal.productSizes.default;
  let index = 'custom';
  let tempWidth = width;
  let tempHeight = height;
  if (dispatch(checkIfCanvasApp())) {
    const {
      canvasRowsCount,
      canvasColumnsCount
    } = getState().finalCheck.project;
    tempWidth = (width / canvasColumnsCount).toFixed(2);
    tempHeight = (height / canvasRowsCount).toFixed(2);
  }
  for (let i = 0; i < productSizes.sizes.length; i++) {
    if (
      (productSizes.sizes[i].width == tempWidth &&
        productSizes.sizes[i].height == tempHeight) ||
      (productSizes.sizes[i].width == tempHeight &&
        productSizes.sizes[i].height == tempWidth)
    ) {
      index = i;
      break;
    }
  }
  if (index === 'custom' && tempWidth && tempHeight) {
    if (!getState().modal.productSizes.custom.sizes) {
      const {
        minCustomWidthImperial,
        maxCustomWidthImperial,
        minCustomWidthMetric,
        maxCustomWidthMetric,
        minCustomHeightImperial,
        maxCustomHeightImperial,
        minCustomHeightMetric,
        maxCustomHeightMetric
      } = getState().modal.storeData;

      const productStack = getState().modal.productSizes;
      productStack.custom.sizes = {
        Imperial: {
          minCustomWidth: minCustomWidthImperial,
          maxCustomWidth: maxCustomWidthImperial,
          minCustomHeight: minCustomHeightImperial,
          maxCustomHeight: maxCustomHeightImperial
        },
        Metric: {
          minCustomWidth: minCustomWidthMetric,
          maxCustomWidth: maxCustomWidthMetric,
          minCustomHeight: minCustomHeightMetric,
          maxCustomHeight: maxCustomHeightMetric
        }
      };
      dispatch({
        type: actions.UPDATE_PRODUCT_SIZES,
        payload: { productSizes: productStack }
      });
    }
    dispatch(setCustomWallSize(width, height));
  }
  if (tempWidth && tempHeight) {
    dispatch(setSelectedDefaultSize(index));
  }
};

export const changeOrientation = () => (dispatch, getState) => {
  const { projectWidth, projectHeight } = getState().home;
  dispatch(selectWall(projectHeight, projectWidth));
  dispatch(updateOrientation(projectHeight, projectWidth));
};

export const updateOrientation = (width, height) => (dispatch, getState) => {
  if (orientationSupportedProducts(getState().modal.envData.category)) {
    const widthFloat = parseFloat(width);
    const heightFloat = parseFloat(height);

    if (widthFloat != heightFloat) {
      let orientation = Constants.PORTRAIT_KEY;
      if (widthFloat > heightFloat) {
        orientation = Constants.LANDSCAPE_KEY;
      }
      dispatch({
        type: actions.ORIENTATION_CHANGED,
        payload: { orientation }
      });
    }
  }
};

export const toggleUnitSystem = () => (dispatch, getState) => {
  const { unitSystem } = getState().home;
  const { activeObject } = getState().fabricCanvas;

  let newUnitSystem = '';
  if (unitSystem === Constants.METRIC_KEY) {
    newUnitSystem = Constants.IMPERIAL_KEY;
  } else {
    newUnitSystem = Constants.METRIC_KEY;
  }
  dispatch({
    type: actions.UNIT_SYSTEM_CHANGED,
    payload: { unitSystem: newUnitSystem }
  });
  dispatch(updateMeasurementLines(activeObject));
};

export const changeContrast = () => (dispatch, getState) => {
  let contrastColor = getState().home.backgroundContrast;
  if (contrastColor === 'light') {
    contrastColor = 'dark';
  } else {
    contrastColor = 'light';
  }
  dispatch({
    type: actions.CONTRAST_CHANGED,
    payload: { backgroundContrast: contrastColor }
  });
};

export const settingsLanguagChange = e => (dispatch, getState) => {
  saveLanguageKey(e.value, getState().modal.storeData.id);
  dispatch(changeLanguage(e));
  if (dispatch(isPosterCategory())) {
    dispatch(
      loadInspirations(
        10,
        { value: getState().sideBar.inspirations.category },
        () => {}
      )
    );
  }
};

export const changeLanguage = e => dispatch => {
  const language = e.value;
  let languageCode = language;
  if (language === 'zh-Hans') {
    languageCode = 'zhS';
  } else if (language === 'zh-Hant') {
    languageCode = 'zhT';
  }
  string.setLanguage(languageCode);
  dispatch({
    type: actions.LANGUAGE_CHANGED,
    payload: { language }
  });
};

export const getUnit = unitSystem => {
  if (unitSystem === Constants.METRIC_KEY) {
    return string.PLACEHOLDER_CM_STRING_KEY;
  }
  return string.PLACEHOLDER_INCHES_STRING_KEY;
};

export const valueInImperial = (valueInUnitSystem, unitSystem) => {
  if (unitSystem === Constants.METRIC_KEY) {
    return parseFloat(
      convertFromMetricToImperial(valueInUnitSystem).toFixed(4)
    );
  }
  return valueInUnitSystem;
};

export const createNewProject = () => dispatch => {
  dispatch(resetProject());
  dispatch(setDefaultWallVanilla());
};

export const setSizeFromApplicationUrl = (productWidth, productHeight) => (
  dispatch,
  getState
) => {
  const { unitSystem } = getState().home;
  const {
    minCustomWidth,
    minCustomHeight
  } = getState().modal.productSizes.custom.sizes[unitSystem];

  dispatch(customWidthChange(productWidth));
  dispatch(customHeightChange(productHeight));
  const { widthValid, heightValid } = getState().home.customWall;

  let validWidthInInches = productWidth;
  let validHeightInInches = productHeight;
  if (unitSystem === Constants.METRIC_KEY) {
    validWidthInInches = convertFromMetricToImperial(productWidth);
    validHeightInInches = convertFromMetricToImperial(productHeight);
  }

  if (widthValid != '') {
    validWidthInInches = minCustomWidth;
  }
  if (heightValid != '') {
    validHeightInInches = minCustomHeight;
  }
  dispatch(
    updateModelsForSelectedWallSize(validWidthInInches, validHeightInInches)
  );
  const activeWall = dispatch(getActiveWall());
  let wallWidth = activeWall.width;
  let wallHeight = activeWall.height;
  if (!dispatch(checkIfCanvasApp())) {
    wallWidth = validWidthInInches;
    wallHeight = validHeightInInches;
  }
  dispatch(
    sizeSettingsAreChanged(
      validWidthInInches,
      validHeightInInches,
      1,
      1,
      wallWidth,
      wallHeight
    )
  );
  dispatch(setCurrentPageIndex(Constants.DESIGN_PAGE));
};

export const setCustomWallSize = (width, height) => dispatch => {
  const widthValid = '';
  const heightValid = '';

  dispatch({
    type: actions.SELECT_CUSTOM_WALL_WIDTH,
    payload: {
      value: width,
      widthInput: width,
      widthValid,
      widthErrorMessage: ''
    }
  });

  dispatch({
    type: actions.SELECT_CUSTOM_WALL_HEIGHT,
    payload: {
      value: height,
      heightInput: height,
      heightValid,
      heightErrorMessage: ''
    }
  });

  dispatch({
    type: actions.CUSTOM_WALL_ERROR,
    payload: { errorMessage: '' }
  });
};

export const updateWallDimension = wall => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const wallObj = new Wall(wall);
  project.activeWall = wallObj;
  project.walls.push(wall);
};

export const filterSupportedProducts = supportedProducts => dispatch => {
  const groupBy = key => array =>
    array.reduce((objectsByKeyValue, obj) => {
      const value = obj[key];

      const turkey = dispatch(isTurkeyLaptop());
      // const belgium = dispatch(isBelgiumLaptop());
      if (turkey) {
        if (dispatch(checkForDesignCompetition())) {
          if (obj.sku === 'ZB_02') {
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(
              obj
            );
          }
        } else if (dispatch(checkForDesignEnterprise())) {
          if (
            obj.sku === 'ZB_02' ||
            obj.sku === 'ZBX_01' ||
            obj.sku === 'ZBS_01'
          ) {
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(
              obj
            );
          }
        } else {
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(
            obj
          );
        }
      } else {
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
      }
      return objectsByKeyValue;
    }, {});

  const groupByFamily = groupBy('laptopFamily');
  const productArrayByFamily = groupByFamily(supportedProducts);
  const productArray = Object.values(productArrayByFamily);
  return productArray;
};

export const shouldShowLegalText = () => dispatch =>
  dispatch(checkIfMaskAppBeforeProductSelection());

export const checkIfLaptopApp = () => dispatch =>
  dispatch(checkIfLaptopAppBeforeProductSelection());

export const checkIfCanvasApp = () => (dispatch, getState) =>
  isCanvasApp(getState().modal.envData.category);

export const checkIfMultiCanvas = () => dispatch => dispatch(isMultiCanvas());

export const setSelectedProduct = product => (dispatch, getState) => {
  const { storeData } = getState().modal;
  if (!dispatch(checkIfCanvasApp())) {
    dispatch({
      type: actions.SET_SELECTED_PRODUCT,
      payload: { selectedProduct: product }
    });
  }

  dispatch({
    type: actions.UPDATE_CATEGORY,
    payload: { value: product.category }
  });

  if (dispatch(checkIfCanvasApp())) {
    dispatch(setCanvasType(Constants.CANVAS));
  }

  if (!isGroupSettingsSupportedApp(product.groupType)) {
    updateStoreWithProductSettings(storeData, product.settings);
    dispatch(initializeProductSizes(storeData));
  }
  const { productSizes } = product;
  if (productSizes.length > 1 || dispatch(checkIfCanvasApp())) {
    dispatch(setCurrentPageIndex(Constants.SIZE_SELECTION_PAGE));
  } else if (!getState().finalCheck.project.id && productSizes.length == 1) {
    const [defaultSize] = productSizes;
    product.activeProductSize = defaultSize;
    const [defaultTemplate] = defaultSize.templates;
    product.activeProductSize.activeTemplate = defaultTemplate;

    // If it is group launch then only reset the project on changing product. Edit link should not reset the project.
    const activeWall = dispatch(getActiveWall());
    dispatch(selectWall(activeWall.width, activeWall.height));
  }
  dispatch(
    generateProductSpecificThemeFolders(getState().modal.themeResponseList)
  );
  dispatch(setSidebarVisibility(false));
  dispatch(handleTabChange(null));
  return Promise.resolve();
};

export const isProductSingle = product => dispatch => {
  if (dispatch(checkIfCanvasApp())) {
    return false;
  }
  if (product.length === Constants.SINGLE_PRODUCT) {
    const [laptop] = product;
    if (laptop.length === Constants.SINGLE_PRODUCT) {
      return true;
    }
    return false;
  }
  return false;
};

export const restartProject = () => (dispatch, getState) => {
  dispatch(resetProject());

  dispatch(setModalPageMode(true));
  getState().finalCheck.project.activeWall = null;
  dispatch({
    type: actions.SET_PROJECT_SIZE,
    payload: { width: null, height: null }
  });
  dispatch({
    type: actions.SET_SELECTED_PRODUCT,
    payload: { selectedProduct: null }
  });
  dispatch(setShowPixelationWarningField(false));
  const { multiWallProjects } = getState().finalCheck;
  if (multiWallProjects.length > 1) {
    getState().finalCheck.multiWallProjects = [];
    getState().finalCheck.activeMultiWallProjectIndex = 0;
    dispatch(setCurrentPageIndex(Constants.SIZE_SELECTION_PAGE));
  } else {
    getState().finalCheck.project.category = null;
    dispatch({
      type: actions.UPDATE_CATEGORY,
      payload: { value: null }
    });
    dispatch(setCurrentPageIndex(Constants.PRODUCT_GROUP_PAGE));
  }
};

export const applicationName = () => (dispatch, getState) => {
  const { category } = getState().modal.envData;
  const { selectedProduct } = getState().home;
  if (selectedProduct) {
    return selectedProduct.name;
  }
  if (category == Constants.NEW_POSTER_CATEGORY) {
    return string.WALL_POSTER_KEY;
  }
  if (category === Constants.GIFTWRAPS_CATEGORY) {
    return string.GIFT_WRAPS_KEY;
  }
  if (category === Constants.WALLPAPER_CATEGORY) {
    return 'Wallcovering';
  }
  if (category === Constants.CANVAS_CATEGORY) {
    return 'Canvas';
  }

  return '';
};
